import React from 'react';
import '../styles/scrollbox.css';

const ScrollBox = ({ children }) => {
    return (
        <div className="scroll-container">
            <div className="scroll-box">
                {children}
            </div>
        </div>
    );
};

export default ScrollBox;
